const extractFromRegexGeneric = (regex: RegExp, text: string) => {
  const matches = regex.exec(text);
  return matches ? matches[0].trim() : '';
};

const createRegexGeneric = (field: string) => {
  return new RegExp(`(?<=${field}:).*`, 'm');
};

export const createRegexSOLITT = (field: string) => {
  return new RegExp(`(?<=${field} :).*`, 'm');
};

export type RegexBuilder = (field: string) => RegExp;
export type ExtractorBuilder = (regex: RegExp, text: string) => string;
export type CreateRegexAndExtractFirst = (field: string, text: string) => string;

export const extractFieldFromTextBuilder = (
  createRegex: RegexBuilder = createRegexGeneric,
  extractFromRegex: ExtractorBuilder = extractFromRegexGeneric
): CreateRegexAndExtractFirst => {
  return function extractField(field: string, text: string) {
    return extractFromRegex(createRegex(field), text);
  };
};
